/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    /**
     * ################# NEW TARIFFS.
     */
    // ********************* CZK *********************
    // lite
    LITE_2024_MONTH_CZK: {
        name: 'LITE_2024_MONTH_CZK',
        price: 170,
    },
    LITE_2024_YEAR_CZK: {
        name: 'LITE_2024_YEAR_CZK',
        price: 1870,
    },
    // profi
    PROFESSIONAL_2024_MONTH_CZK: {
        name: 'PROFESSIONAL_2024_MONTH_CZK',
        price: 350,
    },
    PROFESSIONAL_2024_YEAR_CZK: {
        name: 'PROFESSIONAL_2024_YEAR_CZK',
        price: 3850,
    },
    EXPERT_2024_MONTH_CZK: {
        name: 'EXPERT_2024_MONTH_CZK',
        price: 600,
    },
    EXPERT_2024_YEAR_CZK: {
        name: 'EXPERT_2024_YEAR_CZK',
        price: 6600,
    },
    ULTIMATE_2025_MONTH_CZK: {
        name: 'ULTIMATE_2025_MONTH_CZK',
        price: 1350,
    },
    ULTIMATE_2025_YEAR_CZK: {
        name: 'ULTIMATE_2025_YEAR_CZK',
        price: 14850,
    },
    // ********************* EUR *********************
    LITE_2024_MONTH_EUR: {
        name: 'LITE_2024_MONTH_EUR',
        price: 10,
    },
    LITE_2024_YEAR_EUR: {
        name: 'LITE_2024_YEAR_EUR',
        price: 110,
    },
    PROFESSIONAL_2024_MONTH_EUR: {
        name: 'PROFESSIONAL_2024_MONTH_EUR',
        price: 16,
    },
    PROFESSIONAL_2024_YEAR_EUR: {
        name: 'PROFESSIONAL_2024_YEAR_EUR',
        price: 180,
    },
    EXPERT_2024_MONTH_EUR: {
        name: 'EXPERT_2024_MONTH_EUR',
        price: 26,
    },
    EXPERT_2024_YEAR_EUR: {
        name: 'EXPERT_2024_YEAR_EUR',
        price: 286,
    },
    ULTIMATE_2025_MONTH_EUR: {
        name: 'ULTIMATE_2025_MONTH_EUR',
        price: 72,
    },
    ULTIMATE_2025_YEAR_EUR: {
        name: 'ULTIMATE_2025_YEAR_EUR',
        price: 790,
    },
    // ********************* USD *********************
    LITE_2024_MONTH_USD: {
        name: 'LITE_2024_MONTH_USD',
        price: 17,
    },
    LITE_2024_YEAR_USD: {
        name: 'LITE_2024_YEAR_USD',
        price: 187,
    },
    PROFESSIONAL_2024_MONTH_USD: {
        name: 'PROFESSIONAL_2024_MONTH_USD',
        price: 29,
    },
    PROFESSIONAL_2024_YEAR_USD: {
        name: 'PROFESSIONAL_2024_YEAR_USD',
        price: 319,
    },
    EXPERT_2024_MONTH_USD: {
        name: 'EXPERT_2024_MONTH_USD',
        price: 42,
    },
    EXPERT_2024_YEAR_USD: {
        name: 'EXPERT_2024_YEAR_USD',
        price: 462,
    },
    ULTIMATE_2025_MONTH_USD: {
        name: 'ULTIMATE_2025_MONTH_USD',
        price: 79,
    },
    ULTIMATE_2025_YEAR_USD: {
        name: 'ULTIMATE_2025_YEAR_USD',
        price: 869,
    },
    // ********************* HUF *********************
    LITE_2024_MONTH_HUF: {
        name: 'LITE_2024_MONTH_HUF',
        price: 4000,
    },
    LITE_2024_YEAR_HUF: {
        name: 'LITE_2024_YEAR_HUF',
        price: 44000,
    },
    PROFESSIONAL_2024_MONTH_HUF: {
        name: 'PROFESSIONAL_2024_MONTH_HUF',
        price: 6500,
    },
    PROFESSIONAL_2024_YEAR_HUF: {
        name: 'PROFESSIONAL_2024_YEAR_HUF',
        price: 71500,
    },
    EXPERT_2024_MONTH_HUF: {
        name: 'EXPERT_2024_MONTH_HUF',
        price: 10500,
    },
    EXPERT_2024_YEAR_HUF: {
        name: 'EXPERT_2024_YEAR_HUF',
        price: 115500,
    },
    ULTIMATE_2025_MONTH_HUF: {
        name: 'ULTIMATE_2025_MONTH_HUF',
        price: 29500,
    },
    ULTIMATE_2025_YEAR_HUF: {
        name: 'ULTIMATE_2025_YEAR_HUF',
        price: 324000,
    },
    // ********************* PLN *********************
    LITE_2024_MONTH_PLN: {
        name: 'LITE_2024_MONTH_PLN',
        price: 45,
    },
    LITE_2024_YEAR_PLN: {
        name: 'LITE_2024_YEAR_PLN',
        price: 525,
    },
    PROFESSIONAL_2024_MONTH_PLN: {
        name: 'PROFESSIONAL_2024_MONTH_PLN',
        price: 69,
    },
    PROFESSIONAL_2024_YEAR_PLN: {
        name: 'PROFESSIONAL_2024_YEAR_PLN',
        price: 759,
    },
    EXPERT_2024_MONTH_PLN: {
        name: 'EXPERT_2024_MONTH_PLN',
        price: 119,
    },
    EXPERT_2024_YEAR_PLN: {
        name: 'EXPERT_2024_YEAR_PLN',
        price: 1309,
    },
    ULTIMATE_2025_MONTH_PLN: {
        name: 'ULTIMATE_2025_MONTH_PLN',
        price: 345,
    },
    ULTIMATE_2025_YEAR_PLN: {
        name: 'ULTIMATE_2025_YEAR_PLN',
        price: 3790,
    },
    // ********************* GBP *********************
    LITE_2024_MONTH_GBP: {
        name: 'LITE_2024_MONTH_GBP',
        price: 12,
    },
    LITE_2024_YEAR_GBP: {
        name: 'LITE_2024_YEAR_GBP',
        price: 132,
    },
    PROFESSIONAL_2024_MONTH_GBP: {
        name: 'PROFESSIONAL_2024_MONTH_GBP',
        price: 19,
    },
    PROFESSIONAL_2024_YEAR_GBP: {
        name: 'PROFESSIONAL_2024_YEAR_GBP',
        price: 209,
    },
    EXPERT_2024_MONTH_GBP: {
        name: 'EXPERT_2024_MONTH_GBP',
        price: 29,
    },
    EXPERT_2024_YEAR_GBP: {
        name: 'EXPERT_2024_YEAR_GBP',
        price: 319,
    },
    ULTIMATE_2025_MONTH_GBP: {
        name: 'ULTIMATE_2025_MONTH_GBP',
        price: 65,
    },
    ULTIMATE_2025_YEAR_GBP: {
        name: 'ULTIMATE_2025_YEAR_GBP',
        price: 715,
    },

    /**
     * ################# Legacy tariffs to be compatible due to the migration (new pricing).
     */
    // ********************* CZK *********************
    // freelancer
    FREELANCER_2024_MONTH_COMPATIBILITY_CZK: {
        name: 'FREELANCER_2024_MONTH_COMPATIBILITY_CZK',
        price: 270,
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_CZK: {
        name: 'FREELANCER_2024_YEAR_COMPATIBILITY_CZK',
        price: 2970,
    },
    // ********************* EUR *********************
    FREELANCER_2024_MONTH_COMPATIBILITY_EUR: {
        name: 'FREELANCER_2024_MONTH_COMPATIBILITY_EUR',
        price: 12,
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_EUR: {
        name: 'FREELANCER_2024_YEAR_COMPATIBILITY_EUR',
        price: 132,
    },
    // ********************* USD *********************
    FREELANCER_2024_MONTH_COMPATIBILITY_USD: {
        name: 'FREELANCER_2024_MONTH_COMPATIBILITY_USD',
        price: 19,
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_USD: {
        name: 'FREELANCER_2024_YEAR_COMPATIBILITY_USD',
        price: 209,
    },
    // ********************* HUF *********************
    FREELANCER_2024_MONTH_COMPATIBILITY_HUF: {
        name: 'FREELANCER_2024_MONTH_COMPATIBILITY_HUF',
        price: 5000,
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_HUF: {
        name: 'FREELANCER_2024_YEAR_COMPATIBILITY_HUF',
        price: 55000,
    },
    // ********************* PLN *********************
    FREELANCER_2024_MONTH_COMPATIBILITY_PLN: {
        name: 'FREELANCER_2024_MONTH_COMPATIBILITY_PLN',
        price: 55,
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_PLN: {
        name: 'FREELANCER_2024_YEAR_COMPATIBILITY_PLN',
        price: 605,
    },
    // ********************* GBP *********************
    FREELANCER_2024_MONTH_COMPATIBILITY_GBP: {
        name: 'FREELANCER_2024_MONTH_COMPATIBILITY_GBP',
        price: 15,
    },
    FREELANCER_2024_YEAR_COMPATIBILITY_GBP: {
        name: 'FREELANCER_2024_YEAR_COMPATIBILITY_GBP',
        price: 165,
    },
    // studio
    // ********************* CZK *********************
    STUDIO_2024_MONTH_COMPATIBILITY_CZK: {
        name: 'STUDIO_2024_MONTH_COMPATIBILITY_CZK',
        price: 450,
    },
    STUDIO_2024_YEAR_COMPATIBILITY_CZK: {
        name: 'STUDIO_2024_YEAR_COMPATIBILITY_CZK',
        price: 4950,
    },
    // ********************* EUR *********************
    STUDIO_2024_MONTH_COMPATIBILITY_EUR: {
        name: 'STUDIO_2024_MONTH_COMPATIBILITY_EUR',
        price: 20,
    },
    STUDIO_2024_YEAR_COMPATIBILITY_EUR: {
        name: 'STUDIO_2024_YEAR_COMPATIBILITY_EUR',
        price: 220,
    },
    // ********************* USD *********************
    STUDIO_2024_MONTH_COMPATIBILITY_USD: {
        name: 'STUDIO_2024_MONTH_COMPATIBILITY_USD',
        price: 29,
    },
    STUDIO_2024_YEAR_COMPATIBILITY_USD: {
        name: 'STUDIO_2024_YEAR_COMPATIBILITY_USD',
        price: 317,
    },
    // ********************* HUF *********************
    STUDIO_2024_MONTH_COMPATIBILITY_HUF: {
        name: 'STUDIO_2024_MONTH_COMPATIBILITY_HUF',
        price: 8000,
    },
    STUDIO_2024_YEAR_COMPATIBILITY_HUF: {
        name: 'STUDIO_2024_YEAR_COMPATIBILITY_HUF',
        price: 88000,
    },
    // ********************* PLN *********************
    STUDIO_2024_MONTH_COMPATIBILITY_PLN: {
        name: 'STUDIO_2024_MONTH_COMPATIBILITY_PLN',
        price: 90,
    },
    STUDIO_2024_YEAR_COMPATIBILITY_PLN: {
        name: 'STUDIO_2024_YEAR_COMPATIBILITY_PLN',
        price: 990,
    },
    // ********************* GBP *********************
    STUDIO_2024_MONTH_COMPATIBILITY_GBP: {
        name: 'STUDIO_2024_MONTH_COMPATIBILITY_GBP',
        price: 22,
    },
    STUDIO_2024_YEAR_COMPATIBILITY_GBP: {
        name: 'STUDIO_2024_YEAR_COMPATIBILITY_GBP',
        price: 242,
    },
};
